import Vue, { VNode } from 'vue'
import GridItem from './GridItem'

const Grid = Vue.extend({
  name: 'AheduGrid',
  props: {
    /**
     * 默认间距24px
     */
    gap: {
      type: String,
      default: '24px',
    },
    columns: [String, Number],
    rows: [String, Number],
  },
  render (h): VNode {
    const style = {}

    const { columns, rows, gap } = this

    if (columns) {
      if (typeof columns === typeof 0) {
        style['grid-template-columns'] = `repeat(${columns}, 1fr)`
      } else {
        style['-ms-grid-columns'] = columns
        style['grid-template-columns'] = columns
      }
    }

    if (rows) {
      if (typeof rows === typeof 0) {
        style['grid-template-rows'] = `repeat(${rows}, 1fr)`
      } else {
        style['-ms-grid-rows'] = rows
        style['grid-template-rows'] = rows
      }
    }

    if (gap) {
      style['grid-gap'] = gap
    }

    return h('div', {
      class: 'ahedu-grid',
      style,
    }, this.$slots.default)
  }
})

export default Grid as typeof Grid & {
  Item: typeof GridItem
}